import { useEffect } from 'react';
import { connect } from 'react-redux';
import { projectEntryActions, projectEntrySelectors } from '../../../../store';
import { isObjectWithKeys } from '../../../../helpers';

const Beforeunload = ({ inputEntry, submitTimeEntry, currentSystem }) => {
  useEffect(() => {
    const submitInput = () => {
      if (isObjectWithKeys(inputEntry)) {
        submitTimeEntry(inputEntry, currentSystem);
      }
    };

    window.addEventListener('beforeunload', submitInput);

    return () => (window.removeEventListener('beforeunload', submitInput));
  }, [inputEntry, submitTimeEntry]);

  return null;
};

const mapStateToProps = (state) => ({
  inputEntry: state.projectEntry.inputEntry,
  currentSystem: projectEntrySelectors.selectCurrentSystem(state),
});

const mapDispatchToProps = (dispatch) => ({
  submitTimeEntry: (timeEntry, currentSystem) => dispatch(projectEntryActions.handleSubmit(timeEntry, currentSystem)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Beforeunload);